import React, { useMemo, useState } from 'react'
import withSlideUpModal from '../../utils/hoc/withSlideUpModalComponent'
import { storePAN, validatePAN } from '../../services/api/wallet';
import { toast } from 'react-toastify';
import { getErrorMessage } from '../../utils/helpers';
import { AppDispatch } from '../../redux-stores/store';
import { useDispatch } from 'react-redux';
import { fetchPANDetailsThunk } from '../../redux-stores/slices/influencerSlice';

const LinkPANModal:React.FC<{onClose: () => void}> = ({onClose}) => {

    const [panNumber, setPANNumber] = useState('');
    const [validation, setValidation] = useState<any>(null);
    const [isProcessing, setProcessing] = useState(false);
    const dispatch:AppDispatch = useDispatch();

    const validatePANNumber = () => {
        let lvalidation: any = { status: 'success' };
        if (!panNumber) {
            setValidation({ status: 'failed', message: 'PAN is required!' })
            return false;
        }
        let regex = new RegExp(/^[a-z]{5}[0-9]{4}[a-z]{1}$/i);

        const isValid = regex.test(panNumber.trim());

        if (isValid) {
            setValidation(lvalidation)
            return true;
        };

        setValidation({ status: 'failed', message: 'Invalid PAN' })
        return false;
    }


    const validatePANInfo = async () => {
        const isValid = validatePANNumber();

        if (!isValid || !panNumber.trim()) return;

        try {
            setProcessing(true);
            const serverValidation = await validatePAN(panNumber.trim());
            setValidation({ ...serverValidation, status: 'success' })
        } catch (error: any) {
            setValidation({ status: 'failed', ...(error?.response?.data ?? { message: 'Failed to validate PAN' }) })
            console.log(error)
        } finally {
            setProcessing(false);
        }
    }

    const savePAN = async () => {
        if(!validation?.pan?.id && validation?.status !== 'success') return false;
        try {
            setProcessing(true);
            const result = await storePAN(validation.pan.id);
            console.log(result);
            await dispatch(fetchPANDetailsThunk());
            onClose();
            toast.success("PAN added successfully!")

        } catch (error) {
            console.log(error);
            toast.error(getErrorMessage(error))
        } finally {
            setProcessing(false);
        }
    }

    return (
        <div className='mb-4'>
            <div className="d-flex flex-column">
                <div className="input-style has-borders no-icon input-style-always-active validate-field mb-0">
                    <input type="text" autoComplete="off" className={`form-control validate-number ${validation?.status === 'failed' && 'is-invalid'}`} id="pan" placeholder="Enter PAN"
                        value={panNumber}
                        disabled={validation?.status === 'success' && validation?.pan?.id}
                        onChange={e => setPANNumber((e.target.value ?? '').trim())}
                        onBlur={validatePANNumber}
                    />
                    <label htmlFor="pan" className={`font-12 font-500 ${validation?.status === 'failed' ? 'text-danger' : 'color-highlight'}`}>PAN</label>
                    {
                        validation?.status === 'failed' &&
                        <i className="fas fa-exclamation-circle invalid color-red-dark"></i>
                    }
                    {
                        validation?.status === 'success' && validation?.pan?.id &&
                        <i className="fa fa-check valid color-green-dark"></i>
                    }
                    {
                        !panNumber &&
                        <em>(required)</em>
                    }
                </div>
                {
                    validation?.status === 'success' && validation?.pan?.id &&
                    <div className="d-flex justify-content-between align-items-center mt-0 mx-2">
                        <span className="text-success font-10">{validation?.pan?.registered_name}</span>
                        <button onClick={() => setValidation(null)} className="unset-all text-primary font-10">Change</button>
                    </div>
                }
                {
                    validation?.status === 'failed' &&
                    <span className="text-danger mt-0 ms-2 font-10">{validation?.message ?? 'Failed to validate PAN'}</span>
                }
            </div>
            <div className="divider my-3 mt-0"></div>
            {
                (validation?.status === 'success' && validation?.pan?.id) ? (
                    <button disabled={isProcessing || validation?.status === 'failed' || !panNumber} className="btn btn-sm w-100 btn-primary rounded-sm mb-2" onClick={savePAN}>{isProcessing ? 'Saving...' : 'Save Details'}</button>

                ) : (
                    <button disabled={isProcessing || validation?.status === 'failed' || !panNumber} className="btn btn-sm w-100 btn-primary rounded-sm mb-2" onClick={validatePANInfo}>{isProcessing ? 'Validating...' : 'Validate'}</button>
                )
            }

        </div>
    )
}

export default withSlideUpModal(LinkPANModal, "Link PAN")